var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 10,
    viewBox: "0 0 2 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49691e-07 9C3.2555e-07 8.44772 0.447716 8 1 8C1.55229 8 2 8.44772 2 9C2 9.55228 1.55229 10 1 10C0.447716 10 3.73832e-07 9.55228 3.49691e-07 9Z",
    fill: "#1C1B1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74846e-07 5C1.50704e-07 4.44772 0.447715 4 1 4C1.55229 4 2 4.44772 2 5C2 5.55228 1.55229 6 1 6C0.447716 6 1.98987e-07 5.55228 1.74846e-07 5Z",
    fill: "#1C1B1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0C0.447715 0 -2.41409e-08 0.447715 0 1C2.41414e-08 1.55229 0.447715 2 1 2C1.55228 2 2 1.55229 2 1C2 0.447715 1.55228 0 1 0Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.0e885d542ed253fd7c8ad47093a22894.svg";
export { ForwardRef as ReactComponent };